<template>
	<div class="stability-chart-container">
		<div class="chart-header">
			<!-- <div class="chart-title">{{ title }}</div> -->
			<div class="period-selector">
				<span>统计周期：近半年</span>
			</div>
		</div>
		<div class="chart-content">
			<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
		</div>
	</div>
</template>

<script>
	import JrEcharts from './index.vue'

	// 稳定性分析
	export default {
		name: 'PersonStabilityLineChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			title: {
				type: String,
				default: '稳定性分析'
			},

			// 数据
			chartData: {
				type: Array,
				default: () => []
			},
			// X轴数据（月份）
			xAxisData: {
				type: Array,
				default: () => ['1月', '2月', '3月', '4月', '5月', '6月']
			},
			// 线条颜色
			lineColor: {
				type: String,
				default: '#1890ff'
			}
		},
		data() {
			return {
				periodOptions: [
					{ value: 'month', label: '近一月' },
					{ value: 'quarter', label: '近一季度' },
					{ value: 'halfYear', label: '近半年' },
					{ value: 'year', label: '近一年' }
				]
			}
		},
		computed: {
			chartOptions() {
				return {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line'
						}
					},
					grid: {
						left: '4%',
						right: '4%',
						bottom: '3%',
						top: '11%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.xAxisData,
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#E0E0E0'
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							color: '#666',
							fontSize: 14
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#E0E0E0',
								type: 'solid'
							}
						}
					},
					yAxis: {
						type: 'value',
						minInterval: 1,
						min: 0,
						max: 5,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							color: '#666',
							fontSize: 14
						},
						splitLine: {
							lineStyle: {
								color: '#E0E0E0',
								type: 'solid'
							}
						},
						// 添加Y轴名称
						name: '累计次数',
						nameLocation: 'end',
						nameGap: 13,
						nameTextStyle: {
							fontSize: 14
						}
					},
					series: [
						{
							type: 'line',
							data: this.chartData,
							smooth: false,
							symbol: 'circle',
							symbolSize: 6,
							itemStyle: {
								color: this.lineColor
							},
							lineStyle: {
								width: 2,
								color: this.lineColor
							}
						}
					]
				}
			}
		},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.stability-chart-container {
		.chart-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 10px 0;

			.chart-title {
				font-size: 16px;
				font-weight: 500;
				color: #333;
			}

			.period-selector {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: end;
				font-size: 14px;

				span {
					margin-right: 8px;
					color: #606266;
				}
			}
		}
	}
</style>
